import { render, staticRenderFns } from "./AddressSelection.vue?vue&type=template&id=549bfe46&scoped=true&"
import script from "./AddressSelection.vue?vue&type=script&lang=js&"
export * from "./AddressSelection.vue?vue&type=script&lang=js&"
import style0 from "./AddressSelection.vue?vue&type=style&index=0&id=549bfe46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "549bfe46",
  null
  
)

export default component.exports